import { Box, type BoxProps } from "@mantine/core"
import { toJsxRuntime } from "hast-util-to-jsx-runtime"
import type { ReactNode } from "react"
import * as prod from "react/jsx-runtime"
import remarkGfm from "remark-gfm"
import remarkParse from "remark-parse"
import remarkRehype from "remark-rehype"
import { type Processor, unified } from "unified"

function reactProcessor(this: Processor) {
  this.Compiler = (tree) => toJsxRuntime(tree as any, prod as any)
}

const processor = unified().use(remarkParse).use(remarkGfm).use(remarkRehype).use(reactProcessor).freeze()

export function Markdown({ children, ...props }: { children: string } & BoxProps) {
  return (
    <Box className="markdown" {...props}>
      {processor.processSync(children).result as ReactNode}
    </Box>
  )
}
